"use strict";
angular.module('app', ['app.api', 'stripe', 'FullpageScroll', 'checklist-model', 'dndLists', 'angular.filter', 'ngMessages', 'angularGrid', 'ui.bootstrap', 'duScroll', 'ui.router', 'angularFileUpload', 'jcs-autoValidate', 'ngToast']).config(["$locationProvider", "$stateProvider", "$urlRouterProvider", function($locationProvider, $stateProvider, $urlRouterProvider) {
  $urlRouterProvider.otherwise('/');
  $locationProvider.html5Mode(true);
}]).run(["$rootScope", "$location", function($rootScope, $location) {
  $rootScope.$on('$stateChangeSuccess', function() {
    if ($location.path() !== '/') {
      $rootScope.notMain = true;
    } else {
      $rootScope.notMain = false;
    }
  });
}]).value('duScrollDuration', 1000).directive('compareTo', function() {
  return {
    require: 'ngModel',
    scope: {otherModelValue: '=compareTo'},
    link: function(scope, element, attributes, ngModel) {
      ngModel.$validators.compareTo = function(modelValue) {
        return modelValue === scope.otherModelValue;
      };
      scope.$watch('otherModelValue', function() {
        ngModel.$validate();
      });
    }
  };
}).directive('navBarEffect', ["$window", function($window) {
  return function(scope) {
    angular.element($window).bind('scroll', function() {
      if (this.scrollY >= $window.innerHeight / 2) {
        scope.navEffect = true;
      } else {
        scope.navEffect = false;
      }
      scope.$apply();
    });
  };
}]);

"use strict";
angular.module('app').directive('goTo', ["$location", function($location) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      element.on('click', function() {
        $location.path(attrs.goTo);
        scope.$apply();
      });
    }
  };
}]);

"use strict";
angular.module('app').config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('admin', {
    url: '/admin',
    templateUrl: '../views/admin.html',
    controller: 'authCtrl',
    onEnter: ["$state", "auth", function($state, auth) {
      if (auth.isLoggedIn()) {
        $state.go('admin2');
      }
    }]
  });
}]);

"use strict";
angular.module('app').config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('admin2', {
    url: '/admin2',
    templateUrl: '../views/admin2.html',
    controller: 'adminController',
    onEnter: ["$state", "auth", function($state, auth) {
      if (!auth.isLoggedIn()) {
        $state.go('admin');
      }
    }]
  });
}]).controller('adminController', ["$scope", "storageFactory", "picsFactory", "FileUploader", function($scope, storageFactory, picsFactory, FileUploader) {
  $scope.volunteers = [];
  $scope.emails = [];
  $scope.pics = [];
  storageFactory.allVolunteers(function(data) {
    $scope.volunteers = data;
  });
  storageFactory.allEmails(function(data) {
    $scope.emails = data;
  });
  picsFactory.getPics(function(data) {
    $scope.pics = data;
  });
  $scope.delete = function() {
    $scope.garbage = [];
    for (var x in $scope.pics.Contents) {
      if ($scope.pics.Contents[x].selected === true) {
        $scope.garbage.push($scope.pics.Contents[x].Key);
      }
    }
    picsFactory.deletePics($scope.garbage, function(res) {
      for (var x in $scope.pics.Contents) {
        for (var y in res.Deleted) {
          if ($scope.pics.Contents[x].Key === res.Deleted[y].Key) {
            $scope.pics.Contents.splice($scope.pics.Contents.indexOf($scope.pics.Contents[x]), 1);
          }
        }
      }
    });
  };
  var uploader = $scope.uploader = new FileUploader({
    url: '/newPic',
    removeAfterUpload: true
  });
  uploader.onWhenAddingFileFailed = function(item, filter, options) {
    console.info('onWhenAddingFileFailed', item, filter, options);
  };
  uploader.onAfterAddingFile = function(fileItem) {
    console.info('onAfterAddingFile', fileItem);
  };
  uploader.onAfterAddingAll = function(addedFileItems) {
    console.info('onAfterAddingAll', addedFileItems);
  };
  uploader.onBeforeUploadItem = function(item) {
    item.formData = [{data: 'data'}];
    console.info('onBeforeUploadItem', item);
  };
  uploader.onProgressItem = function(fileItem, progress) {
    console.info('onProgressItem', fileItem, progress);
  };
  uploader.onProgressAll = function(progress) {
    console.info('onProgressAll', progress);
  };
  uploader.onSuccessItem = function(fileItem, response, status, headers) {
    console.info('onSuccessItem', fileItem, response, status, headers);
  };
  uploader.onErrorItem = function(fileItem, response, status, headers) {
    console.info('onErrorItem', fileItem, response, status, headers);
  };
  uploader.onCancelItem = function(fileItem, response, status, headers) {
    console.info('onCancelItem', fileItem, response, status, headers);
  };
  uploader.onCompleteItem = function(fileItem, response, status, headers) {
    $scope.pics.Contents.push({Key: fileItem.file.name});
    console.info('onCompleteItem', fileItem, response, status, headers);
  };
  uploader.onCompleteAll = function() {
    console.info('onCompleteAll');
  };
}]);

"use strict";
angular.module('app.api', ['app.api.auth', 'app.api.pics', 'app.api.storage']);

"use strict";
angular.module('app.api.auth', []).factory('auth', ["$http", "$window", "$state", function($http, $window, $state) {
  var auth = {};
  auth.saveToken = function(token) {
    $window.localStorage['angel-token'] = token;
  };
  auth.getToken = function() {
    return $window.localStorage['angel-token'];
  };
  auth.isLoggedIn = function() {
    var token = auth.getToken();
    if (token) {
      var payload = JSON.parse($window.atob(token.split('.')[1]));
      return payload.exp > Date.now() / 1000;
    } else {
      return false;
    }
  };
  auth.currentUser = function() {
    if (auth.isLoggedIn()) {
      var token = auth.getToken();
      var payload = JSON.parse($window.atob(token.split('.')[1]));
      return payload.username;
    }
  };
  auth.register = function(user) {
    return $http.post('/register', user).success(function(data) {
      auth.saveToken(data.token);
    });
  };
  auth.logIn = function(user) {
    return $http.post('/login', user).success(function(data) {
      auth.saveToken(data.token);
    });
  };
  auth.logOut = function() {
    $window.localStorage.removeItem('angel-token');
    $state.go('index');
  };
  auth.userCount = function(callback) {
    return $http.get('/users').success(function(res) {
      if (res.status === 'error') {
        console.log('error in getting userCount');
      } else {
        callback(res);
      }
    });
  };
  return auth;
}]);

"use strict";
angular.module('app').controller('authCtrl', ["$scope", "$state", "auth", function($scope, $state, auth) {
  $scope.user = {};
  $scope.loggedIn = false;
  $scope.register = function() {
    auth.register($scope.user).error(function(error) {
      console.log(error);
      $scope.error = error;
    }).then(function() {
      $state.go('admin2');
    });
  };
  $scope.logIn = function() {
    auth.logIn($scope.user).error(function(error) {
      $scope.error = error;
    }).then(function() {
      $state.go('admin2');
    });
  };
}]);

"use strict";
angular.module('app').config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('bod', {
    url: '/bod',
    templateUrl: '../views/bod.html'
  });
}]);

"use strict";
angular.module('app').config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('faq', {
    url: '/faq',
    templateUrl: '../views/faq.html'
  });
}]);

"use strict";
angular.module('app').directive('footer', function() {
  return {
    restrict: 'A',
    templateUrl: 'views/footer.html',
    link: function(scope) {
      scope.text = '© Lockeroom Enterprises, LLC';
    }
  };
});

"use strict";
angular.module('app').controller('headerCtrl', ["$location", "$scope", "auth", function($location, $scope, auth) {
  $scope.$location = $location;
  $scope.isLoggedIn = auth.isLoggedIn;
  $scope.currentUser = auth.currentUser;
  $scope.logOut = auth.logOut;
  auth.userCount(function(data) {
    $scope.userCount = data;
  });
}]).directive('header', function() {
  return {
    restrict: 'A',
    templateUrl: 'views/header.html',
    link: function() {}
  };
});

"use strict";
angular.module('app').config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('history', {
    url: '/history',
    templateUrl: '../views/history.html'
  });
}]);

"use strict";
angular.module('app').config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('learn', {
    url: '/learn',
    templateUrl: '../views/learn.html'
  });
}]);

"use strict";
angular.module('app').config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('index', {
    url: '/',
    templateUrl: '../views/main.html',
    controller: 'mainController'
  });
}]).controller('mainController', ["$scope", "storageFactory", "picsFactory", "$uibModal", "angularGridInstance", "ngToast", "$state", function($scope, storageFactory, picsFactory, $uibModal, angularGridInstance, ngToast, $state) {
  $scope.start = true;
  $scope.volunteers = [];
  $scope.pics = [];
  picsFactory.getPics(function(data) {
    $scope.pics = data;
  });
  $scope.learn = function() {
    $state.go('learn');
  };
  $scope.animationsEnabled = true;
  $scope.open = function(size) {
    var modalInstance = $uibModal.open({
      animation: $scope.animationsEnabled,
      templateUrl: 'myModalContent.html',
      controller: 'ModalInstanceCtrl',
      size: size,
      resolve: {}
    });
  };
  $scope.newEmail = function() {
    storageFactory.addEmails($scope.emailList, function(data) {
      $scope.emails = data;
      $scope.emailList = {};
      $scope.beInKnow.$setPristine();
      ngToast.create({
        className: 'success',
        content: '<a>Your Email has been Saved!</a>'
      });
    });
  };
}]);
angular.module('app').controller('ModalInstanceCtrl', ["$scope", "$uibModalInstance", "storageFactory", "ngToast", function($scope, $uibModalInstance, storageFactory, ngToast) {
  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.newVol = function() {
    $scope.volunteerForm.createdAt = new Date();
    storageFactory.addVolunteer($scope.volunteerForm, function(data) {
      if (data) {
        ngToast.create({
          className: 'success',
          content: '<a>Your Information has been Saved!</a>'
        });
        $scope.volunteers = data;
        $scope.volunteerForm = {};
        $scope.volunteer.$setPristine();
        $uibModalInstance.dismiss('cancel');
      }
    });
  };
}]);

"use strict";
angular.module('app.api.pics', []).factory('picsFactory', ["$http", function($http) {
  var factory = {};
  var pics = [];
  factory.getPics = function(callback) {
    $http.get('/pics').success(function(res) {
      if (res.status === 'error') {
        console.log('error in getting pics');
      } else {
        pics = res;
        callback(pics);
      }
    }).catch(function(err) {
      console.log(err);
    });
  };
  factory.deletePics = function(data, callback) {
    $http.post('/delPics', data).success(function(res) {
      if (res.status === 'error') {
        console.log('error in deleting pics');
      } else {
        callback(res);
      }
    });
  };
  return factory;
}]);

"use strict";
angular.module('app.api.storage', []).factory('storageFactory', ["$http", function($http) {
  var factory = {};
  var volunteers = [];
  var emails = [];
  factory.allVolunteers = function(callback) {
    $http.get('/volunteers').success(function(res) {
      if (res.status === 'error') {
        console.log('error in loading volunteers');
      } else {
        volunteers = res;
        callback(volunteers);
      }
    });
  };
  factory.addVolunteer = function(newVol, callback) {
    $http.post('/volunteer/new', newVol).success(function(res) {
      console.log(res);
      if (res.status === 'error') {
        console.log('error with adding volunteer');
      } else {
        volunteers.push(res);
        callback(volunteers);
      }
    });
  };
  factory.allEmails = function(callback) {
    $http.get('/emails').success(function(res) {
      if (res.status === 'error') {
        console.log('error in loading emails');
      } else {
        emails = res;
        callback(emails);
      }
    });
  };
  factory.addEmails = function(email, callback) {
    $http.post('/email/new', email).success(function(res) {
      if (res.status === 'error') {
        console.log('error with adding email');
      } else {
        emails.push(res);
        callback(emails);
      }
    });
  };
  return factory;
}]);

"use strict";
angular.module('app').config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('projects', {
    url: '/projects',
    templateUrl: '../views/projects.html'
  });
}]);

"use strict";
angular.module('app').config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('purpose', {
    url: '/purpose',
    templateUrl: '../views/ourPurpose.html',
    controller: 'purposeCtrl'
  });
}]).controller('purposeCtrl', function() {});

"use strict";
